import { isSSR } from '@helpers';

const device = isSSR()
  ? { windows: true }
  : {
    windows: /^Win/i.test(navigator.platform),
    mac: /^Mac/i.test(navigator.platform),
    android:
        /Android/i.test(navigator.userAgent) ||
        /webOS/i.test(navigator.userAgent),
    ios:
        /iPhone|iPad|iPod/i.test(navigator.platform) ||
        (/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 0)
  };

export default device;

export function isMobile() {
  return !isSSR() && (device.ios || device.android);
}

export function isDesktop() {
  return isSSR() || (!device.ios && !device.android);
}
